import brand from './brand'
import series from './series'

export default {
  mixins: [brand, series],

  data () {
    return {
      brandId: '',
      seriesId: ''
    }
  },

  created () {
    this.loadBrandList()
  },

  watch: {
    brandId () {
      this.loadSeriesList(this.brandId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/brandAndSeries.js